"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../hooks");
var _CetComponentsProvider = require("../../../../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles() {
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors,
    language = _useContext.language;
  var ccTaskManagerAssignToStyle = (0, _react.useMemo)(function () {
    var deviceProps = function deviceProps() {
      if (!isMobileView) {
        return {
          height: '100%',
          overflow: 'hidden',
          minHeight: pxToRem(300)
        };
      }
      return {};
    };
    var ccTaskManagerAssignTo = (0, _css.css)(_objectSpread({
      display: 'flex',
      flexDirection: 'column'
    }, deviceProps()));
    var ccTaskManagerAssignToSelect = (0, _css.css)({
      marginBottom: pxToRem(12)
    });
    var ccTaskManagerAssignToAlert = (0, _css.css)({
      paddingInlineStart: pxToRem(14),
      lineHeight: 1.4,
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.alert,
      fontSize: pxToRem(isMobileView ? 16 : 14),
      width: isMobileView || language === 'en' ? 'auto' : '90%',
      fontWeight: 'bold',
      marginBottom: pxToRem(12)
    });
    var ccTaskManagerAssignToAudience = (0, _css.css)({
      flex: 'auto',
      overflowX: 'hidden',
      overflowY: 'auto'
    });
    return {
      ccTaskManagerAssignTo: ccTaskManagerAssignTo,
      ccTaskManagerAssignToSelect: ccTaskManagerAssignToSelect,
      ccTaskManagerAssignToAlert: ccTaskManagerAssignToAlert,
      ccTaskManagerAssignToAudience: ccTaskManagerAssignToAudience
    };
  }, [isMobileView, language, pxToRem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.alert]);
  return {
    'cc-TaskManager__assign-to': ccTaskManagerAssignToStyle.ccTaskManagerAssignTo,
    'cc-TaskManager__assign-to__select': ccTaskManagerAssignToStyle.ccTaskManagerAssignToSelect,
    'cc-TaskManager__assign-to__alert': ccTaskManagerAssignToStyle.ccTaskManagerAssignToAlert,
    'cc-TaskManager__assign-to__audience': ccTaskManagerAssignToStyle.ccTaskManagerAssignToAudience
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;